<template>
  <section>
    <div>
      <SeoHero
        :left-image="require('~/assets/images/cargo/Cargo-bike-left-side.svg')"
        :right-image="
          require('~/assets/images/cargo/Cargo-bike-right-side.svg')
        "
        left-position="-90px"
        right-position="10px"
        bike-type="cargo"
        @cta="handleClick"
      >
        Cargo Bike Insurance <br />
        You Can Trust
      </SeoHero>

      <div class="container">
        <Featured />
        <CargoBikeInsurance />
        <RideWithConfidence />
        <BlogWidget
          title="Learn more about cargo bikes and cycling safety"
          :slugs="[
            'guide-to-cargo-bikes',
            'highway-code-changes-every-cyclist-should-know',
            'how-to-lock-your-bike-the-right-way',
            'can-cyclist-be-sued-cause-accident',
          ]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Featured from '@/components/homepage/Featured'
import CargoBikeInsurance from '@/components/cargo/CargoBikeInsurance'
import RideWithConfidence from '@/components/cargo/RideWithConfidence'
import SeoHero from '@/components/seo/SeoHero'
import BlogWidget from '@/components/blog-widget/BlogWidget'
import { buildSocialMeta, resolveSocialImage } from '@/helpers/social-meta'
import { productOffer } from '@/helpers/product-offer'

// og:image and Product.image both read this, so the two cannot drift apart.
const OG_IMAGE_PATH = '/images/og/cargo-bike-insurance-1200x630.png'

// The bike this page is about: drives the CTA href and the modal prefill.
const BIKE_TYPE = 'cargo'

export default {
  name: 'CargoBikeInsurancePage',
  components: {
    Featured,
    CargoBikeInsurance,
    RideWithConfidence,

    BlogWidget,
    SeoHero,
  },
  data() {
    return {
      page: {
        title: 'Cargo Bike Insurance (You Can Trust) | Pedalsure',
        meta_description:
          'Protect your cargo bike with complete cover from Pedalsure. We cover your cargo bike and accessories against theft, accidental damage and loads more.',
      },
    }
  },
  head() {
    return {
      title: this.page.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.meta_description,
        },
        { hid: 'title', name: 'title', content: this.page.title },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'commuter insurance, road, cycling',
        },
        ...buildSocialMeta({
          title: this.page.title,
          description: this.page.meta_description,
          path: this.$route.path,
          image: OG_IMAGE_PATH,
          type: 'website',
        }).meta,
      ],
      script: [
        {
          innerHTML: `
        {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Cargo Bike Insurance",
          "logo": "https://www.pedalsure.com/Pedalsure-Logo_Large.svg",
          "image": ${JSON.stringify([resolveSocialImage(OG_IMAGE_PATH)])},
          "description": "Protect your cargo bike with complete cover from Pedalsure. We cover your cargo bike and accessories against theft, accidental damage and loads more",
           "brand": {
            "@type": "Brand",
            "name": "Pedalsure"
          },
          "offers": ${JSON.stringify(productOffer())}
        }
        `,
          type: 'application/ld+json',
        },
      ],
    }
  },
  methods: {
    ...mapActions('quote', {
      resetQuote: 'resetQuote',
    }),
    handleClick() {
      this.resetQuote()
      // Same values the CTA's href carries, so a quote started from the modal
      // is attributed identically to one started by following the link.
      this.$modal.show('quick-quote', {
        bikeType: BIKE_TYPE,
        src: `lp-${BIKE_TYPE}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>

<style lang="scss" scoped>
/* Hero styling now lives in components/seo/SeoHero.vue */
</style>
